export default {
  portal: {
    login: {
      title: '登录',
      username: '用户名',
      inputUsername: '请输入用户名',
      password: '密码',
      inputPassword: '请输入密码',
      checkCode: '验证码',
      inputCheckCode: '请输入验证码',
      loginText: '登录',
      slider: '滑块验证',
      getVeriCode: '获取验证码',
      veriCodeInfo: '请输入验证码',
      veriCode: '验证码',
      sliderFalse: '滑块验证失败',
      usernameNotEmpty: '用户名不能为空',
      passwordNotEmpty: '密码不能为空',
      pwdReadyTip: '密码已经到期，点击确认进行修改！',
      pwdExpireTip: '密码即将到期，请及时修改！',
      pwdSameDefaultTip: '密码和初始密码一致，请修改',
      userRepeateLogin: '当前账号已在其他IP登录，是否继续登录？'
    },
    profile: {
      title: '个人中心',
      username: '用户名：',
      realName: '真实姓名：',
      mobile: '手机号：',
      email: '邮箱：',
      changePwd: '修改密码',
      editProfile: '编辑资料',
      orginPwd: '原始密码：',
      inputOrginPwd: '请输入原始密码',
      newPwd: '新密码：',
      inputNewPwd: '请输入新密码',
      confirmPwd: '确认密码：',
      saveValid: '请完成安全验证',
      inputConfirmPwd: '请确认新密码',
      passwordValid1: '新密码长度要在{0}~{1}之间',
      passwordValid2: '新密码需要包含',
      passwordValid3: '密码不一致！',
      passwordValid4: '原始密码不能为空！',
      passwordValid5: '新密码不能为空！',
      passwordValid6: '确认密码不能为空！',
      mobileValid1: '格式错误，只能输入数字、-',
      emailValid1: '邮箱格式不正确',
      authCode: '权限代码',
      authName: '权限名称',
      comment: '说明',
      validate1: '数字',
      validate2: '英文字母',
      validate3: '特殊字符',
      validate4: '字母大小写',
      cancel: '取消',
      confirm: '确定',
      operSuccTip: '操作成功',
      checkInputTip: '请检查输入'
    }
  }
}
